/**
 * Stable CSS class names for E2E — Lost cargo return detail.
 */
export const LCRD = {
    page: 'lost-cargo-return-detail-page',
    loadingSection: 'lost-cargo-return-detail-page__loading-section',
    breadcrumbWrap: 'lost-cargo-return-detail-page__breadcrumb-wrap',
    emptyStateMessage: 'lost-cargo-return-detail-page__empty-message',

    summaryCard: 'lost-cargo-return-detail-summary-card',
    summaryCardHeader: 'lost-cargo-return-detail-summary-card__header',
    summaryCardTitle: 'lost-cargo-return-detail-summary-card__title',
    summaryStatusChip: 'lost-cargo-return-detail-summary-card__status-chip',
    inputButtonReturnStatusHistory: 'lost-cargo-return-detail-summary-card-input--button-status-history',
    statusHistoryDrawerPaper: 'lost-cargo-return-detail-status-history-drawer',

    infoCard: 'lost-cargo-return-detail-info-card',
    infoCardGrid: 'lost-cargo-return-detail-info-card__grid',
    infoRow: 'lost-cargo-return-detail-info-card__row',
    infoLabel: 'lost-cargo-return-detail-info-card__label',
    infoValue: 'lost-cargo-return-detail-info-card__value',
    linkCustomerManagement: 'lost-cargo-return-detail-info-card-input--link-customer',
    linkShippingList: 'lost-cargo-return-detail-info-card-input--link-shipping-list',
    linkOrderDetail: 'lost-cargo-return-detail-info-card-input--link-order',

    completingOverlay: 'lost-cargo-return-detail-grid__completing-overlay',
    imagePreviewDialogPaper: 'lost-cargo-return-detail-image-preview-dialog',
    inputIconImagePreviewClose: 'lost-cargo-return-detail-image-preview-dialog-input--icon-close',
    imagePreviewContent: 'lost-cargo-return-detail-image-preview-dialog__content',
    imagePreviewImg: 'lost-cargo-return-detail-image-preview-dialog__img',

    returnProductDrawerPaper: 'lost-cargo-return-detail-product-drawer',

    rowActionsPopoverPaper: 'lost-cargo-return-detail-row-actions-popover',
    inputMenuItemTakeAction: 'lost-cargo-return-detail-row-actions-input--menu-item-take-action',

    gridOuter: 'lost-cargo-return-detail-grid__outer',
    gridPaper: 'lost-cargo-return-detail-grid__paper',
    barcodeSearchFieldWrap: 'lost-cargo-return-detail-grid__barcode-field',
    inputCompositeBarcodeSearch: 'lost-cargo-return-detail-grid-input--composite-barcode-search',
    inputTextBarcodeSearch: 'lost-cargo-return-detail-grid-input--text-barcode-search',
    inputButtonBarcodeSearch: 'lost-cargo-return-detail-grid-input--button-barcode-search',

    barcodeNotFoundSection: 'lost-cargo-return-detail-grid__barcode-not-found',
    linkOrdersWithBarcode: 'lost-cargo-return-detail-grid-input--link-orders-with-barcode',

    productsTableContainer: 'lost-cargo-return-detail-products-table',
    productsTable: 'lost-cargo-return-detail-products-table__table',
    productRow: 'lost-cargo-return-detail-products-table__row',
    productImageCell: 'lost-cargo-return-detail-products-table__image-cell',
    productImageWrap: 'lost-cargo-return-detail-products-table__image-wrap',
    inputIconProductImageZoom: 'lost-cargo-return-detail-products-table-input--icon-zoom',
    productDetailCell: 'lost-cargo-return-detail-products-table__detail-cell',
    linkProductDetail: 'lost-cargo-return-detail-products-table-input--link-product-detail',
    tableFooterTotal: 'lost-cargo-return-detail-products-table__footer-total',
    inputIconRowActions: 'lost-cargo-return-detail-products-table-input--icon-row-actions',
    inputButtonCompleteReturn: 'lost-cargo-return-detail-grid-input--button-complete-return',

    approveModalBody: 'lost-cargo-return-detail-approve-modal__body',
    approveModalProductSection: 'lost-cargo-return-detail-approve-modal__product-section',
    approveModalQuantitySection: 'lost-cargo-return-detail-approve-modal__quantity-section',
    inputSelectApproveRestock: 'lost-cargo-return-detail-approve-modal-input--select-restock',
    inputSelectApproveNonRestock: 'lost-cargo-return-detail-approve-modal-input--select-non-restock',
    inputSelectApproveOperatorReason: 'lost-cargo-return-detail-approve-modal-input--select-operator-reason',

    searchFormPage: 'lost-cargo-return-detail-search-form-page',
    searchFormContentWrap: 'lost-cargo-return-detail-search-form__content-wrap',
    searchFormCompositeWrap: 'lost-cargo-return-detail-search-form__composite-wrap',
    searchFormComposite: 'lost-cargo-return-detail-search-form-input--composite-search',
    searchFormSelectType: 'lost-cargo-return-detail-search-form-input--select-search-type',
    searchFormTextQuery: 'lost-cargo-return-detail-search-form-input--text-query',
    searchFormButtonSearch: 'lost-cargo-return-detail-search-form-input--button-search',
} as const;

export const lcrDetailCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
